export default __webpack_public_path__ + "static/media/640_dummy2016-tennisclub01-mobile-de.c70d6cdb.png";